import { PatientAppointment } from '../../../services/appointment/types';

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { Box } from '@mui/system';
import moment from 'moment';
import {
  DotSeparatedTitle,
  ListItem
} from '../../layout/slideout/patient-profile-widget/patient-profile-widget.styles';
import { getApptStatus } from '../../layout/slideout/patient-profile-widget/views/visits/utils/get-appt-status';

type UpcomingAppointmentItemProps = {
  appointment: PatientAppointment;
  onClick: (appointment: PatientAppointment) => void;
};

export const UpcomingAppointmentItem = ({ appointment, onClick }: UpcomingAppointmentItemProps) => {
  return (
    <ListItem className='upcoming-appointment-item' key={appointment.id} icon={<CalendarTodayIcon />} onClick={onClick}>
      <DotSeparatedTitle
        leftTitle={appointment.date ? moment(appointment.date).format('MM/DD/YYYY') : null}
        rightTitle={getApptStatus(appointment)}
      ></DotSeparatedTitle>
      {!!appointment.description && <Box sx={{ paddingTop: '8px', fontSize: '14px' }}>{appointment.description}</Box>}
    </ListItem>
  );
};
